import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("ul", {
        "data-slot": "sidebar-menu-sub",
        "data-sidebar": "menu-badge",
        class: _normalizeClass($setup.cn('border-en-blue-200 mx-3.5 flex min-w-0 translate-x-px flex-col gap-1 px-2.5 py-0.5 list-none', 'group-data-[collapsible=icon]:hidden', $setup.props.class))
    }, [
        _renderSlot(_ctx.$slots, "default")
    ], 2 /* CLASS */));
}
